/* file description */

// 获取树形节点的最深层级
export function getMaxFloor(treeData: any[] = []) {
  let max = 0;
  function each(data: any[] = [], floor: number) {
    data.forEach((e) => {
      e.floor = floor;
      if (floor > max) {
        max = floor;
      }
      if (e.children?.length > 0) {
        each(e.children, floor + 1);
      }
    });
  }
  each(treeData, 1);
  return max;
}
